import { generateQueryString } from '@/utils/helpers'
import { baseApi } from '../baseApi'
import type { Dictionary } from '@/types'

export const paymentManagement = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentStats: builder.query<Dictionary, Record<string, any>>({
      query: (param) => ({
        url: `/payments/statistics${generateQueryString(param)}`,
        method: 'GET',
      }),
      providesTags: ['Payments'],
      transformResponse: (response: any) => response.data,
    }),
    getAllPayments: builder.query<Dictionary, Record<string, any>>({
      query: (param) => ({
        url: `/payments${generateQueryString(param)}`,
        method: 'GET',
      }),
      providesTags: ['Payments'],
      transformResponse: (response: any) => response.data,
    }),
    getRefund: builder.query<Dictionary, { refund_id: string }>({
      query: ({ refund_id }) => ({
        url: `/refunds/${refund_id}`,
        method: 'GET',
      }),
      providesTags: ['Refunds'],
      transformResponse: (response: any) => response.data,
    }),
  }),
})

export const {
  useGetPaymentStatsQuery,
  useGetAllPaymentsQuery,
  useGetRefundQuery,
} = paymentManagement
